import { render, staticRenderFns } from "./messageGroupAdd.vue?vue&type=template&id=1ddfb66a&scoped=true&"
import script from "./messageGroupAdd.vue?vue&type=script&lang=js&"
export * from "./messageGroupAdd.vue?vue&type=script&lang=js&"
import style0 from "./messageGroupAdd.vue?vue&type=style&index=0&id=1ddfb66a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddfb66a",
  null
  
)

export default component.exports